import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SgiInformacaoDocumentada } from 'src/app/shared/interfaces/sgi-informacao-documentada/sgi-informacao-documentada.interface';
import { SgiInformacaoDocumentadaAPIService } from 'src/app/modules/sgi-informacao-documentada/services/sgi-informacao-documentada-api.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-documento-pendente-item',
  templateUrl: './documento-pendente-item.component.html'
})
export class DocumentoPendenteItemComponent {
  @Input() doc!: SgiInformacaoDocumentada;
  @Output() navegar = new EventEmitter<SgiInformacaoDocumentada>();

  linkAnexo = `${environment.AnexoEndpoint}`;

  expandido = false;
  observacao = '';
  arquivos: { nome: string; base64: string }[] = [];
  aguardandoRevisao = false;
  enviando = false;
  anexos: any[] = [];
  carregandoAnexos = false;

  // O solicitante analisou e o documento não precisou de mudança. Dispensa o anexo — não
  // há versão nova para enviar — e chega marcado na tela de análise do SGI.
  semAlteracao = false;

  constructor(
    private sgiService: SgiInformacaoDocumentadaAPIService,
    private toastr: ToastrService
  ) {}

  toggleExpand(): void {
    this.expandido = !this.expandido;

    if (this.expandido && !this.anexos.length && !this.carregandoAnexos) {
      this.carregandoAnexos = true;
      this.sgiService.getDocumentacao(this.doc.id).subscribe({
        next: (res) => {
          this.anexos = Array.isArray(res) ? res : [];
          this.carregandoAnexos = false;
        },
        error: () => {
          this.anexos = [];
          this.carregandoAnexos = false;
        }
      });
    }
  }

  onFileSelected(event: any): void {
    const files = event.target.files as FileList;
    if (!files?.length) return;

    Array.from(files).forEach(file => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = (reader.result as string).split(',')[1];
        this.arquivos = [...this.arquivos, { nome: file.name, base64 }];
      };
      reader.readAsDataURL(file);
    });

    event.target.value = '';
  }

  removerArquivo(index: number): void {
    this.arquivos = this.arquivos.filter((_, i) => i !== index);
  }

  /** Ao marcar, os arquivos já escolhidos são descartados: não há versão nova a enviar. */
  onSemAlteracaoChange(): void {
    if (this.semAlteracao) this.arquivos = [];
  }

  // A observação continua obrigatória nos dois casos — é ela que conta ao SGI o que foi
  // analisado. O anexo só é exigido quando houve mudança de fato.
  get podEnviar(): boolean {
    const temArquivoSeNecessario = this.semAlteracao || this.arquivos.length > 0;
    return !!(this.observacao.trim()) && temArquivoSeNecessario && !this.enviando && !this.aguardandoRevisao;
  }

  enviarSolicitacao(): void {
    const obs = this.observacao.trim();
    if (!obs) {
      this.toastr.warning('Informe as observações sobre a análise do documento.', 'Atenção');
      return;
    }
    if (!this.semAlteracao && !this.arquivos.length) {
      this.toastr.warning('Anexe ao menos um arquivo com a nova versão do documento.', 'Atenção');
      return;
    }

    this.enviando = true;

    const anexosDTO = this.arquivos.map(a => ({
      id: 0,
      isCreated: true,
      isDeleted: false,
      isUpdated: false,
      nome: a.nome,
      anexo: a.base64,
      tabelaOrigemId: this.doc.id,
      tabelaOrigemNome: 'sgi_informacao_documentada',
      tipoAnexo: 'documento',
      dataCriacao: null,
      usuarioCriacaoId: 0
    }));

    this.sgiService.enviarSolicitacaoRevisao({
      sgiInformacaoDocumentadaId: this.doc.id,
      observacaoUsuario: obs,
      semAlteracao: this.semAlteracao,
      anexos: anexosDTO
    }).subscribe({
      next: () => {
        this.toastr.success('Solicitação enviada! Aguarde a análise do SGI.', 'Sucesso');
        this.aguardandoRevisao = true;
        this.enviando = false;
      },
      error: (err) => {
        const msg = err?.error?.message || 'Erro ao enviar solicitação';
        this.toastr.error(msg, 'Erro');
        this.enviando = false;
      }
    });
  }
}
